import React from 'react'

export default function MentionIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="4" stroke="#64617E" strokeWidth="1.5" />
            <path d="M16 8V13C16 14.6569 17.3431 16 19 16C20.6569 16 22 14.6569 22 13V12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C13.8214 22 15.5291 21.513 17 20.6622" stroke="#64617E" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}
